import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { LogIn } from '../_models/log-in';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  public static readonly SIGN_UP_CONTROLLER_URL=environment.apiURL+"login/"
  
  public login(logInDataForm: LogIn):Observable<HttpResponse<LogIn>>{
    {
      return this.http.post<LogIn>(LoginService.SIGN_UP_CONTROLLER_URL , logInDataForm ,{ observe: 'response' })
      .pipe(map(response => {
        localStorage.setItem('loginDetails',JSON.stringify(response))
        return response;
      }));
  }
  }
}
